import SAWD3A1XE10EU2 from './SAWD-3A1XE10EU2.js';
import SAWD3A2XE10EU2 from './SAWD-3A2XE10EU2.js';
import SAWD2A1XX10EU1 from './SAWD-2A1XX10EU1.js';
import SAWD1A1XX10EU1 from './SAWD-1A1XX10EU1.js';
import SAWD0A1XX10EU1 from './SAWD-0A1XX10EU1.js';
import SAWD4A1XE10US0 from './SAWD-4A1XE10US0.js';
import SAWD5A1XE10EU0 from './SAWD-5A1XX10EU0.js';
import SAWD6A1XX10EU0 from './SAWD-6A1XX10EU0.js';
import SAWD6A0XX0EU0 from './SAWD-6A0XX0EU0.js';

export const Android = {
	'SAWD-3A1XE10EU2': SAWD3A1XE10EU2, //wall display xl
	'SAWD-3A2XE10EU2': SAWD3A2XE10EU2, //wall display xl
	'SAWD-2A1XX10EU1': SAWD2A1XX10EU1, //wall display x2
	'SAWD-1A1XX10EU1': SAWD1A1XX10EU1, //wall display 2
	'SAWD-0A1XX10EU1': SAWD0A1XX10EU1, //wall display
	'SAWD-4A1XE10US0': SAWD4A1XE10US0, //wall display x1i
	'SAWD-5A1XX10EU0': SAWD5A1XE10EU0, //wall display x2i
	'SAWD-6A1XX10EU0': SAWD6A1XX10EU0, //wall display x1i
	'SAWD-6A0XX0EU0': SAWD6A0XX0EU0, //wall display d1
}; //Pako- as temporary solution i've removed input_type and invert_input from the wall display devices because of the issue with the wall display x1i and x2i changed with https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/work_items/2919
